export default collection =>
  [...collection].sort(
    (element, nextElement) => element.order - nextElement.order
  );
